import {
  Box,
  Divider,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Switch,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import DateTime from "components/ui/DateTime";
import InfoList from "components/ui/InfoList";
import PeriodTime from "components/ui/PeriodTime";
import { useResource } from "hooks/useResource";
import { useNavigate, useParams } from "react-router-dom";
import { ACTION_NAMES } from "./LogHistory";

const AGENDA_ACTIONS = {
  selected: "Selecionou os tópicos",
  removed: "Removeu os tópicos",
  highlighted: "Alterou destaque dos tópicos",
  imported: "Importou automaticamente os tópicos",
  highlightSummary: "Alterou o resumo de destaques",
};

export default function ViewLog() {
  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });
  const navigate = useNavigate();
  const { logId } = useParams();
  const { data: log } = useResource({
    id: logId as string,
    resourceName: "log",
    path: "logs",
  });

  return (
    <Modal
      variant="form"
      isOpen={isOpen}
      onClose={onClose}
      onCloseComplete={() => navigate("../..", { relative: "path" })}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          Histórico de alterações
          <span>Veja as alterações realizadas</span>
          {log && (
            <>
              <InfoList
                mt="10px"
                ml={0}
                justifyContent="flex-start"
                spacing="35px"
              >
                <Box>
                  <Text as="span">
                    <small>Data</small>
                    <DateTime date={log.createdAt} noBreak />
                  </Text>
                </Box>
                <Box>
                  <Text as="span">
                    <small>Usuário</small>
                    <Text>{log.user?.name}</Text>
                  </Text>
                </Box>
                <Box>
                  <Text as="span">
                    <small>Ação</small>
                    <Text>{ACTION_NAMES[log.action]}</Text>
                  </Text>
                </Box>
              </InfoList>
              <Divider mt="20px" mb={0} />
            </>
          )}
        </ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          {log && (
            <>
              {log.data.agenda && (
                <Box>
                  <Heading as="h4" size="h4" color="bg.button.primary">
                    Dados da agenda
                  </Heading>

                  <InfoList
                    mt="10px"
                    ml="15px"
                    justifyContent="flex-start"
                    spacing="35px"
                  >
                    <Box>
                      <Text as="span">
                        <small>Assunto do e-mail</small>
                        <Text>{log.data.agenda?.title}</Text>
                      </Text>
                    </Box>
                    <Box>
                      <Text as="span">
                        <small>Cliente</small>
                        <Text>{log.data.agenda?.companyName}</Text>
                      </Text>
                    </Box>
                    <Box>
                      <Text as="span">
                        <small>Modelo de disparo</small>
                        <Text>{log.data.agenda?.contentGroupName}</Text>
                      </Text>
                    </Box>
                    <Box>
                      <Text as="span">
                        <small>Lista</small>
                        <Text>{log.data.agenda?.listName}</Text>
                      </Text>
                    </Box>
                    <Box>
                      <Text as="span">
                        <small>Período</small>
                        <PeriodTime
                          startsAt={log.data.agenda?.startsAt}
                          endsAt={log.data.agenda?.endsAt}
                          noBreakLine
                        />
                      </Text>
                    </Box>
                  </InfoList>
                  <Divider mt="20px" mb="10px" />
                </Box>
              )}
              {Object.entries(log.data.topics).map(([key, items]) => (
                <Box key={key} mt="10px">
                  {(!Array.isArray(items) ||
                    (Array.isArray(items) && items.length > 0)) && (
                    <Heading as="h4" size="h4" color="bg.button.primary">
                      {AGENDA_ACTIONS[key]}
                    </Heading>
                  )}
                  {Array.isArray(items) && items.length > 0 && (
                    <>
                      <TableContainer ml="15px">
                        <Table>
                          <Tbody>
                            {items.map((item, i) => (
                              <Tr key={i}>
                                <Td>
                                  <Switch
                                    isChecked={item.highlighted}
                                    disabled
                                  />
                                </Td>
                                <Td>
                                  <Text>{item.noteTitle}</Text>
                                  <Box my="6px">
                                    <Text
                                      as="span"
                                      dangerouslySetInnerHTML={{
                                        __html: item.noteTopicText,
                                      }}
                                    />
                                  </Box>
                                  <Text as="span">
                                    <i>{item.noteTopicCreatedByName}</i>
                                  </Text>
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        </Table>
                      </TableContainer>
                      <Divider mt="20px" mb="10px" />
                    </>
                  )}
                  {key === "highlightSummary" && (
                    <Box
                      dangerouslySetInnerHTML={{
                        __html: log.data.highlightSummary,
                      }}
                    />
                  )}
                </Box>
              ))}
            </>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
